export const NO_MAX_DATE_VALUE = `unlimited`;

export const INCOMPLETE_RANGE_CLASS = `incomplete-range`;
